import styled from "styled-components"
import {lighten} from "polished"

interface StyledProps {
  delay?: boolean,
  forMobile?: boolean,
  width?: number
}

export const Wrapper = styled.div<StyledProps>`
  position: relative;
  bottom: 0px;
  width: 100%;
  height: 8px;
  background-color: ${({theme}) => theme.colors.greys.light};
  pointer-events: none;
  user-select: none;
  border-radius: 5px;
  display: flex;
  ${({forMobile}) => (forMobile ? "width: calc(100% - 30px);" : "")}
`

export const Seek = styled.div<StyledProps>`
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 5px;
  background: linear-gradient(to right, ${({theme}) => lighten(0.3, theme.colors.perkbox.blue)}, ${({theme}) => theme.colors.perkbox.blue});
  transition: width ${({delay}) => (delay ? "1s" : "0.25s")} ease;
  width: ${({width}) => `${width}%`};
`
